import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const DashboardQuickActions = ({ role = 'influencer' }) => {
  const navigate = useNavigate();

  const quickActions = {
    influencer: [
      {
        title: 'Submit Purchase',
        description: 'Upload receipt and earn rewards',
        icon: 'Upload',
        path: '/transaction-submission-screen',
        variant: 'default'
      },
      {
        title: 'View Earnings',
        description: 'Track your rewards and payouts',
        icon: 'DollarSign',
        path: '/user-dashboard',
        variant: 'secondary'
      },
      {
        title: 'Update Profile',
        description: 'Manage your social accounts',
        icon: 'User',
        path: '/user-onboarding-screen',
        variant: 'outline'
      }
    ],
    brand: [
      {
        title: 'Create Campaign',
        description: 'Launch new influencer campaign',
        icon: 'PlusCircle',
        path: '/brand-dashboard',
        variant: 'default'
      },
      {
        title: 'View Analytics',
        description: 'Track campaign performance',
        icon: 'BarChart3',
        path: '/brand-dashboard',
        variant: 'secondary'
      },
      {
        title: 'Manage Profile',
        description: 'Update brand information',
        icon: 'Building2',
        path: '/user-onboarding-screen',
        variant: 'outline'
      }
    ],
    admin: [
      {
        title: 'Review Submissions',
        description: 'Moderate pending transactions',
        icon: 'FileCheck',
        path: '/admin-panel',
        variant: 'default'
      },
      {
        title: 'User Management',
        description: 'Manage platform users',
        icon: 'Users',
        path: '/admin-panel',
        variant: 'secondary'
      },
      {
        title: 'Platform Settings',
        description: 'Configure system settings',
        icon: 'Settings',
        path: '/admin-panel',
        variant: 'outline'
      }
    ]
  };

  const currentActions = quickActions?.[role] || quickActions?.influencer;

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="dashboard-quick-actions">
      {currentActions?.map((action, index) => (
        <div key={index} className="quick-action-card">
          <div className="quick-action-icon">
            <Icon name={action?.icon} size={24} />
          </div>
          <h3 className="quick-action-title">{action?.title}</h3>
          <p className="quick-action-description">{action?.description}</p>
          <Button
            variant={action?.variant}
            onClick={() => handleActionClick(action?.path)}
            iconName="ArrowRight"
            iconPosition="right"
            fullWidth
          >
            Get Started
          </Button>
        </div>
      ))}
    </div>
  );
};

export default DashboardQuickActions;